import { createFileRoute } from '@tanstack/react-router';

import { redirectIfAuthenticated } from '@/app/guards';
import { ForgotPasswordPage } from '@/features/auth';

export const Route = createFileRoute('/(public)/forgot-password')({
  beforeLoad: redirectIfAuthenticated,
  component: ForgotPasswordPage,
});
